import { useEffect, useState } from "react";
import { karelImages } from "../../runtime/karelImages";

/**
 * Waits for the shared Karel sprites to load, triggering the load itself if no
 * other component (e.g. the IDE) has started it yet. `KarelView` cannot draw
 * Karel without these sprites, so thumbnails gate on this hook.
 */
export function useKarelImagesReady(): boolean {
  const [ready, setReady] = useState(() => karelImages.haveLoadedAllImages());

  useEffect(() => {
    if (karelImages.haveLoadedAllImages()) {
      setReady(true);
      return;
    }
    if (!karelImages.haveCalledLoadImages()) {
      karelImages.loadImages();
    }
    const onLoaded = (): void => setReady(true);
    karelImages.addListener(onLoaded);
    return () => karelImages.removeListener(onLoaded);
  }, []);

  return ready;
}
